import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import headSrc from '@cover/weiterdenken/head.svg';
import gearSrc from '@cover/weiterdenken/gear.svg';
import eyebrowLeftSrc from '@cover/weiterdenken/eyebrow-left.svg';
import eyebrowRightSrc from '@cover/weiterdenken/eyebrow-right.svg';
import mouthSrc from '@cover/weiterdenken/mouth.svg';


const AnimatedLayer = styled.img`
	position: absolute;
`

// gears
const GearOne = styled(AnimatedLayer)`
	height: 27%;
	left: 42%;
	top: -3%;
`
const GearTwo = styled(AnimatedLayer)`
	height: 14%;
	left: 33%;
	top: 19%;
`
const GearThree = styled(AnimatedLayer)`
	height: 10%;
	left: 50.5%;
	top: 28.5%;
`
const GearFour = styled(AnimatedLayer)`
	height: 4.5%;
	left: 44.5%;
	top: 38.5%;
`
const GearFive = styled(AnimatedLayer)`
	height: 3.5%;
	left: 50%;
	top: 53.6%;
`
const GearSix = styled(AnimatedLayer)`
	height: 2%;
	left: 47.4%;
	top: 58.6%;
`

// head
const Head = styled(AnimatedLayer)`
	height: 42.5%;
	left: 26.5%;
	top: 57%;
`
const EyebrowLeft = styled(AnimatedLayer)`
	height: 3.5%;
	left: 42.4%;
	top: 69.2%;
	transform-origin: right top;
`
const EyebrowRight = styled(AnimatedLayer)`
	height: 3.5%;
	left: 56%;
	top: 69.2%;
	transform-origin: left top;
`
const Mouth = styled(AnimatedLayer)`
	height: 4.4%;
	left: 48%;
	top: 83.3%;
	transform-origin: right top;
`

const WeiterDenken = ({ play }) => {

	const gearOne = createRef();
	const gearTwo = createRef();
	const gearThree = createRef();
	const gearFour = createRef();
	const gearFive = createRef();
	const gearSix = createRef();

	const head = createRef();
	const mouth = createRef();
	const eyebrowLeft = createRef();
	const eyebrowRight = createRef();

	useEffect(() => {
		// gears
		const timeline = anime.timeline({
			autoplay: play,
			loop: true,
		});

		timeline
		.add({
			targets: [gearOne.current, gearThree.current, gearFive.current],
			easing: 'linear',
			rotate: 360,
			duration: 6000
		})
		.add({
			targets: [gearTwo.current, gearFour.current, gearSix.current],
			easing: 'linear',
			rotate: -360,
			duration: 6000
		}, 0);


		// head
		const timeline2 = anime.timeline({
			autoplay: play,
			loop: true,
		});

		timeline2
		.add({
			targets: eyebrowLeft.current,
			easing: 'easeInOutSine',
			delay: 2100,
			keyframes: [
				{translateY: '-35%', rotate: -3, duration: 400, endDelay: 2000},
				{translateY: '0%', rotate: 0},
			]
		}, 0)
		.add({
			targets: eyebrowRight.current,
			easing: 'easeInOutSine',
			delay: 2000,
			keyframes: [
				{translateY: '-30%', rotate: 3, duration: 400, endDelay: 2100},
				{translateY: '0%', rotate: 0},
			]
		}, 0)
		.add({
			targets: mouth.current,
			easing: 'easeInOutSine',
			duration: 1200,
			keyframes: [
				{rotate: 6, translateY: '-25%', endDelay: 1000},
				{rotate: 0, translateY: '0%'},
			]
		}, '-=3200');

	}, [play])
	return (
		<>
			<GearOne src={gearSrc} ref={gearOne}/>
			<GearTwo src={gearSrc} ref={gearTwo}/>
			<GearThree src={gearSrc} ref={gearThree}/>
			<GearFour src={gearSrc} ref={gearFour}/>
			<GearFive src={gearSrc} ref={gearFive}/>
			<GearSix src={gearSrc} ref={gearSix}/>
			<Head src={headSrc} ref={head}/>
			<EyebrowLeft src={eyebrowLeftSrc} ref={eyebrowLeft}/>
			<EyebrowRight src={eyebrowRightSrc} ref={eyebrowRight}/>
			<Mouth src={mouthSrc} ref={mouth}/>
		</>
	)
};

export default WeiterDenken;